// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1jGFG","vLegacy":"SelectSecondary_vLegacy__x3jvd","error":"SelectSecondary_error__3gBtu","disabled":"SelectSecondary_disabled__3V7JP"};